import React from "react";
import store from "../../Store";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import getOrganization from "../../ajax/actions/organization/organization_get";
import {
  resetSearchParams,
  setOrganizationFailedID,
} from "./OgranizationFailed-Action";
import getOrganizationFailedTnx from "../../ajax/actions/failed-site-transactions/organizationFailed-get";

class OrganizationFailedWorker extends React.Component {
  componentDidMount() {
    const { id } = this.props.match.params;
    store.dispatch(resetSearchParams());
    store.dispatch(getOrganizationFailedTnx(id));
    store.dispatch(setOrganizationFailedID(id));
    store.dispatch(getOrganization(id));
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  let { getOrganization } = state;

  return { getOrganization };
}

export default withRouter(connect(mapStateToProps)(OrganizationFailedWorker));
